module.exports = __webpack_public_path__ + "static/media/medialibrary.347ca676.svg";